import * as React from 'react';
import {IClaim} from '../../../../../../data/api/models';
import {Col, ControlLabel, FormGroup, Row} from 'react-bootstrap';
import {Field, FieldArray} from 'redux-form';
import {
  isRequired,
  normalizeCurrency,
  normalizeYear,
  isNotShorterThan, isValidDob, minAge, maxAge, isValidDate,
} from '../../../../../../util/validators';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import * as moment from 'moment';
import SelectControl from '../../../../../../components/SelectControl';
import FaCheck from 'react-icons/fa/check';
import { get } from 'lodash';
import TitleField from '../../../../../../components/TitleField';
import AlternativeDatePicker from '../../../../../../components/AlternativeDatePicker';
import FaTrash from 'react-icons/fa/trash';

interface IClaimProps {
  index: number;
  claim: IClaim;
  name: string;
  dispatch: any;
  change: any;
  claimOptions: any;
  deleteClaim: any;
  removable: boolean;
}

class Claim extends React.Component<IClaimProps> {
  private handleDeleteClaim = (index) => (e) => {
    const { deleteClaim } = this.props;
    deleteClaim(index);
  }

  private renderClaimDate() {
    const { name } = this.props;

    return (
      <FormGroup controlId="claim.date">
        <Col componentClass={ControlLabel} sm={6}>
          What was the date of the claim?
        </Col>
        <Col sm={6}>
          <div className="alternative-date-picker">
            <div className="field">
              <Field
                name={name + '.date'}
                id={name + '-date-text-field'}
                type="masked-date"
                placeholder="dd/mm/yyyy"
                component={FieldFormControl}
              />
            </div>
            <div className="icon">
              <Field
                name={name + '.date'}
                maxDate={moment()}
                component={AlternativeDatePicker}
                validate={[
                  isRequired,
                  isValidDate,
                ]}
              />
            </div>
          </div>
        </Col>
      </FormGroup>
    );
  }

  private renderType() {
    const { name, claimOptions } = this.props;

    return (
      <Row>
        <Col componentClass={ControlLabel} sm={6}>
          Type of incident:
        </Col>
        <Col sm={4}>
          <FormGroup controlId={'claim.type'}>
            <Col sm={12} className="no-padding-left">
              <Field
                type="text"
                name={name + '.type'}
                component={SelectControl}
                validate={[ isRequired ]}
                options={claimOptions}
                placeholder="Please Select"
              />
            </Col>
          </FormGroup>
        </Col>
      </Row>
    );
  }

  private renderCost() {
    const { name } = this.props;
    return (
      <Row>
        <Col componentClass={ControlLabel} sm={6}>
          Total Claims Cost Paid and Reserved/Outstanding:
        </Col>
        <Col sm={4}>
          <FormGroup controlId={'claim.cost'}>
            <Col sm={12} className="no-padding-left">
              <Col sm={10}>
                <Field
                  addOn={'£'}
                  addOnClassName={['input-group-vehicle-value']}
                  currency={true}
                  type="inputGroup"
                  name={name + '.cost'}
                  normalize={normalizeCurrency}
                  component={FieldFormControl}
                  validate={[ isRequired ]}
                  placeholder="0"
                />
              </Col>
            </Col>
          </FormGroup>
        </Col>
      </Row>
    );
  }

  private renderFault() {
    const { name } = this.props;

    return (
      <Row>
        <Col componentClass={ControlLabel} sm={6}>
          Was the claim paid out by your insurer, and not the third party insurer?
        </Col>
        <Col sm={6}>
          <Col sm={12}>
            <Row className="button-group-container">
              <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                <Field
                  name={name + '.fault'}
                  type="radio"
                  value="false"
                  component={FieldFormControl}
                  validate={[isRequired]}
                >
                  <div className={'button-group-btn'}>
                    No
                    <FaCheck/>
                  </div>
                </Field>
              </Col>
              <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                <Field
                  name={name + '.fault'}
                  type="radio"
                  value="true"
                  component={FieldFormControl}
                  validate={[isRequired]}
                >
                  <div className={'button-group-btn'}>
                    Yes
                    <FaCheck/>
                  </div>
                </Field>
              </Col>
            </Row>
          </Col>
        </Col>
      </Row>
    );
  }

  private renderOpen() {
    const { name } = this.props;

    return (
      <Row>
        <Col componentClass={ControlLabel} sm={6}>
          Is this claim still open?
        </Col>
        <Col sm={6}>
          <Col sm={12}>
            <Row className="button-group-container">
              <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                <Field
                  name={name + '.open'}
                  type="radio"
                  value="false"
                  component={FieldFormControl}
                  validate={[isRequired]}
                >
                  <div className={'button-group-btn'}>
                    No
                    <FaCheck/>
                  </div>
                </Field>
              </Col>
              <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                <Field
                  name={name + '.open'}
                  type="radio"
                  value="true"
                  component={FieldFormControl}
                  validate={[isRequired]}
                >
                  <div className={'button-group-btn'}>
                    Yes
                    <FaCheck/>
                  </div>
                </Field>
              </Col>
            </Row>
          </Col>
        </Col>
      </Row>
    );
  }

  public render() {
    const {index, claim, removable} = this.props;

    return (
      <div className="sub-title">
        <Row>
          <Col sm={11} className="vehicle-info-centre-subtitle">
            Claim {index + 1}
          </Col>
          {removable && (
            <Col sm={1}>
              <div
                className="pointer"
                onClick={this.handleDeleteClaim(index)}
              >
                <FaTrash />
              </div>
            </Col>
          )}
        </Row>
        {this.renderClaimDate()}
        {claim && (
          <>
            {claim.date && (
              <>
                {this.renderType()}
              </>
            )}
            {claim.type && (
              <>
                {this.renderCost()}
                {this.renderFault()}
              </>
            )}
            {claim.fault && (
              <>
                {this.renderOpen()}
              </>
            )}
          </>
        )}
      </div>
    );
  }
}

export default Claim;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Drivers/components/Claim/index.tsx